module.exports = __webpack_public_path__ + "static/media/mode-571.b0bf18c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-571.svg
// module id = 1079
// module chunks = 2